import { apiClient } from 'utils/api/apiClient'

// filesize limit that mandates that we use the presigned urls
export const MAX_STANDARD_FILESIZE = 2 ** 20 * 4 // 4MB

// maximum filesize allowed at all - you cannot upload a file larger than this
export const MAX_ALLOWED_FILESIZE = 2 ** 20 * 100

export const getBase64 = async (file) => {
  var reader = new FileReader()
  // return a promise that will only resolve once the onload event
  // happens. This way we can await it
  return new Promise((resolve) => {
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.readAsDataURL(file)
  })
}

export const fileNameWithTimestamp = (file) => {
  const fileNameParts = file.name.split('.')
  const extension = `.${fileNameParts[fileNameParts.length - 1]}`
  return `${file.name.replace(extension, `_${Date.now()}${extension}`)}`
}

export const largeFileUpload = async (file, isAdmin, userId) => {
  const { data } = await apiClient.put(
    `${isAdmin && userId ? '/admin' : ''}/documents/upload_presign`,
    {
      fileName: fileNameWithTimestamp(file),
      userId,
      contentType: file.type,
    }
  )
  const presignedUrl = data

  const largeUploadResponse = await fetch(presignedUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  })
  return largeUploadResponse.status
}

export const standardSizeFileUpload = async (file, uploadPath) => {
  if (!file.dataURL) {
    file.dataURL = await getBase64(file)
  }
  return await apiClient.post(uploadPath, {
    file,
    fileName: fileNameWithTimestamp(file),
  })
}
